import { FieldTypeIcon } from "@/shared/components/ResourceView/Filters/fieldTypeIcons";
import {
  CustomFieldType,
  customFieldTypeIconType,
} from "@/shared/domain/customFields";

import { customFieldTypeLabel } from "./customFieldPresentation";
import styles from "./CustomFieldsTable.module.css";

interface CustomFieldTypeCellProps {
  type: CustomFieldType;
}

export function CustomFieldTypeCell({ type }: CustomFieldTypeCellProps) {
  return (
    <span className={styles.typeCell}>
      <FieldTypeIcon
        type={customFieldTypeIconType(type)}
        className={styles.typeIcon}
      />
      {customFieldTypeLabel(type)}
    </span>
  );
}
